"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBasicImageProps_1 = __importDefault(require("./utils/getBasicImageProps"));
const getWidths_1 = __importDefault(require("./utils/getWidths"));
const buildImageUrl_1 = __importStar(require("./utils/buildImageUrl"));
const defaults_1 = require("./defaults");
function getGatsbyImage(imageRaw, args) {
    if (imageRaw.endsWith('.svg')) {
        return null;
    }
    // reset when url containing image config
    const image = imageRaw.replace(/\/m\/[^.]*$/, '');
    const imageProps = (0, getBasicImageProps_1.default)(image);
    // url not identified as Storyblok image
    if (!imageProps) {
        return null;
    }
    const options = {
        ...defaults_1.defaultOptions,
        ...args
    };
    const { metadata: { dimensions }, originalPath } = imageProps;
    const width = options.width || 0;
    const height = options.height || 0;
    const desiredAspectRatio = width && height ? width / height : dimensions.aspectRatio;
    let outputWidth;
    let outputHeight;
    let sizes;
    // Get output width and height
    switch (true) {
        case options.layout === 'fullWidth':
            outputWidth = desiredAspectRatio;
            outputHeight = 1;
            break;
        case width && !height:
            outputWidth = width;
            outputHeight = Math.round(width / desiredAspectRatio);
            break;
        case Boolean(!width && height):
            outputWidth = Math.round(height * desiredAspectRatio);
            outputHeight = height;
            break;
        case Boolean(width && height):
            outputWidth = width;
            outputHeight = height;
            break;
        case !width && !height:
        default:
            outputWidth = dimensions.width;
            outputHeight = dimensions.height;
            break;
    }
    switch (options.layout) {
        case 'constrained':
            sizes = `(min-width: ${outputWidth}px) ${outputWidth}px, 100vw`;
            break;
        case 'fullWidth':
            sizes = '100vw';
            break;
        case 'fixed':
        default:
            sizes = `${outputWidth}px`;
            break;
    }
    const widths = (0, getWidths_1.default)(options, outputWidth, dimensions.width);
    const srcSetArr = widths.map((currentWidth) => {
        const resolution = `${currentWidth}w`;
        const currentHeight = Math.round(currentWidth / desiredAspectRatio);
        // Workaround for Storyblok has bug when crop with width larger than 4000 (eg: crop 5000 will get 4000)
        // Not to set crop when size is same to source
        const sameToSource = currentWidth === dimensions.width && currentHeight === dimensions.height;
        const url = (0, buildImageUrl_1.default)(originalPath, {
            ...options,
            width: sameToSource ? undefined : currentWidth,
            height: sameToSource ? undefined : currentHeight
        });
        return `${url} ${resolution}`;
    });
    const src = (0, buildImageUrl_1.default)(originalPath, { ...options, width, height });
    return {
        layout: options.layout,
        placeholder: {
            sources: [],
            fallback: options.fallback === false ? null : (0, buildImageUrl_1.buildLowFiUrl)(originalPath, options)
        },
        backgroundColor: options.backgroundColor || 'transparent',
        images: {
            fallback: {
                src,
                srcSet: srcSetArr.join(',\n') || null,
                sizes
            },
            sources: []
        },
        width: outputWidth,
        height: outputHeight
    };
}
exports.default = getGatsbyImage;
